jQuery(function($) {
  var pageTop = $('.orchard-hero__header').offset();
  var $window = $(window);
  $(".orchard-subscribe-button").addClass('orchard-slide');
  $window.scroll(function() {
      if ( $window.scrollTop() >= pageTop.top+200) {
        $(".orchard-subscribe-button").removeClass('orchard-slide');
      }
      if ( $window.scrollTop() < pageTop.top+200) {
        $(".orchard-subscribe-button").addClass('orchard-slide');
      }
  });

  /*** ADA Compliance Changes ***/
  // Adds "required" to each input field in the form.
  $(document).on('opened', '.orchard-subscribe-modal', function(){
    $('.form-renderer .input-field input').each(function(){
      $(this).attr('required','true');
    });

    // Adds visual asterisk to required fields+
    if($('.field-required-label').length === 0) {
      let indication_text = document.createElement('p');
      indication_text.innerText = "* indicates a required field";
      indication_text.setAttribute('aria-label', 'Field Required Label');
      indication_text.setAttribute('class', 'field-required-label');
      $('.form-renderer .form-holder').before(indication_text);
      $('.form-renderer .phone-field').attr("placeholder", "Your phone number*");
      $('.form-renderer .email-field').attr("placeholder", "Your email address*"); 
    }

    // Add for attribute for Aria-label on country selector
    $('.country-select').attr("for", "Country");

    // Add "ID" to Modal Heading, and "aria-labelledby" to modal wrapper
    $('.orchard-subscribe-modal__wysiwyg .header-text').attr("id", "orchard-modal-header");
    $('.orchard-subscribe-modal').attr("aria-labelledby","orchard-modal-header");
  });
});